<template>
  <vx-card title="Обращения">
    <div class="mb-10">
      <IconWithStatistics
        icon="ArrowDownIcon"
        title="Новых уникальных<br>лидов"
        :count="new_unique_leads_count"
        color="#29c76f"
      />
    </div>
    <div class="mb-10">
      <IconWithStatistics
        icon="ArrowDownIcon"
        title="Повторных уникальных<br>лидов"
        :count="recurring_unique_leads_count"
        color="#ff9e43"
      />
    </div>
    <div class="mb-10">
      <IconWithStatistics
        icon="UserIcon"
        title="Количество<br>обращений"
        :count="sessions_count"
        color="#7470e8"
      />
    </div>
    <div>
      <IconWithStatistics
        icon="ClockIcon"
        title="Среднее время ответа<br>оператора"
        :count="operator_response_time_avg | secToTime"
        color="#7470e8"
      />
    </div>
  </vx-card>
</template>

<script>
import IconWithStatistics from './IconWithStatistics'

export default {
  props: {
    sessions: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      new_unique_leads_count: this.sessions.new_unique_leads_count || 0,
      operator_response_time_avg: this.sessions.operator_response_time_avg || 0,
      recurring_unique_leads_count: this.sessions.recurring_unique_leads_count || 0,
      sessions_count: this.sessions.sessions_count || 0
    }
  },

  created () {

  },

  components: {
    IconWithStatistics
  }
}
</script>
